module.exports = __webpack_public_path__ + "img/DevEcoTesting.77e2e977.png";